// extracted by mini-css-extract-plugin
module.exports = {"card":"_82e3db2ea0--card--cVQRX","counter":"_82e3db2ea0--counter--CXBaL","arrow":"_82e3db2ea0--arrow--VAP0S","description":"_82e3db2ea0--description--xMLkG"};